import { memo } from "react";
import SettingsItem from "./settings-item";
import SwitchToggle from "../../../common/switch-toggle";
import { LucideIcon } from "lucide-react-native";

interface SettingsToggleProps {
  title: string;
  description: string;
  value: boolean;
  onValueChange: (value: boolean) => void;
  icon?: LucideIcon;
  disabled?: boolean;
  children?: React.ReactNode;
}

const SettingsToggle = memo(function SettingsToggle({
  title,
  description,
  value,
  onValueChange,
  icon: Icon,
  disabled = false,
  children,
}: SettingsToggleProps) {
  return (
    <SettingsItem
      title={title}
      description={description}
      icon={Icon}
      disabled={disabled}
      leftItem={
        <SwitchToggle
          value={value}
          onValueChange={onValueChange}
          disabled={disabled}
        />
      }
    >
      {children}
    </SettingsItem>
  );
});

export default SettingsToggle;
